export class PermissionNames {
    private static readonly Verbs = {
        Read: 'read',
        Write: 'write'
    } as const;

    static readonly RailPerformance = {
        Base: 'rail_performance',
        Read: `rail_performance:${PermissionNames.Verbs.Read}`,

        KnowledgeBase: {
            Base: 'rail_performance.knowledge_base',
            Read: `rail_performance.knowledge_base:${PermissionNames.Verbs.Read}`,
            Write: `rail_performance.knowledge_base:${PermissionNames.Verbs.Write}`
        },

        RailStateComparison: {
            Base: 'rail_performance.railstatecomparison',
            Read: `rail_performance.railstatecomparison:${PermissionNames.Verbs.Read}`
        },

        Reports: {
            Base: 'rail_performance.reports',
            Read: `rail_performance.reports:${PermissionNames.Verbs.Read}`,
            Write: `rail_performance.reports:${PermissionNames.Verbs.Write}`
        }
    } as const;

    static readonly ForecastDemand = {
        Base: 'forecast_demand',
        Read: `forecast_demand:${PermissionNames.Verbs.Read}`,

        Exports: {
            Base: 'forecast_demand.exports',
            Write: `forecast_demand.exports:${PermissionNames.Verbs.Write}`
        },

        ForecastTemplate: {
            Base: 'forecast_demand.forecast_template',
            Read: `forecast_demand.forecast_template:${PermissionNames.Verbs.Read}`,
            Write: `forecast_demand.forecast_template:${PermissionNames.Verbs.Write}`
        },

        KnowledgeBase: {
            Base: 'forecast_demand.knowledge_base',
            Read: `forecast_demand.knowledge_base:${PermissionNames.Verbs.Read}`
        }
    } as const;

    static readonly PlatformManagement = {
        Base: 'platform_management',

        Permissions: {
            Base: 'platform_management.permissions',
            Read: `platform_management.permissions:${PermissionNames.Verbs.Read}`,
            Write: `platform_management.permissions:${PermissionNames.Verbs.Write}`
        },

        Roles: {
            Base: 'platform_management.roles',
            Read: `platform_management.roles:${PermissionNames.Verbs.Read}`,
            Write: `platform_management.roles:${PermissionNames.Verbs.Write}`
        },

        Tenants: {
            Base: 'platform_management.tenants',
            Read: `platform_management.tenants:${PermissionNames.Verbs.Read}`,
            Write: `platform_management.tenants:${PermissionNames.Verbs.Write}`
        },

        Users: {
            Base: 'platform_management.users',
            Read: `platform_management.users:${PermissionNames.Verbs.Read}`,
            Write: `platform_management.users:${PermissionNames.Verbs.Write}`,

            Passwords: {
                Base: 'platform_management.users.passwords',
                Write: `platform_management.users.passwords:${PermissionNames.Verbs.Write}`
            }
        },

        KnowledgeBase: {
            Base: 'platform_management.knowledge_base',
            Read: `platform_management.knowledge_base:${PermissionNames.Verbs.Read}`,
            Write: `platform_management.knowledge_base:${PermissionNames.Verbs.Write}`
        }
    } as const;

    static readonly RailImpact = {
        Base: 'rail_impact',
        Read: `rail_impact:${PermissionNames.Verbs.Read}`,

        KnowledgeBase: {
            Base: 'rail_impact.knowledge_base',
            Read: `rail_impact.knowledge_base:${PermissionNames.Verbs.Read}`
        }
    } as const;

    static readonly RailIndustry = {
        Base: 'rail_industry',

        Network: {
            Base: 'rail_industry.network',
            Read: `rail_industry.network:${PermissionNames.Verbs.Read}`
        },

        Associations: {
            Base: 'rail_industry.associations',
            Read: `rail_industry.associations:${PermissionNames.Verbs.Read}`
        },

        Shippers: {
            Base: 'rail_industry.shippers',
            Read: `rail_industry.shippers:${PermissionNames.Verbs.Read}`
        }
    } as const;

    static readonly RsiAi = {
        Base: 'rsi_ai',
        Read: `rsi_ai:${PermissionNames.Verbs.Read}`
    } as const;
}
